

















































import uuid from "uuid";
import { Prop, Component, Vue } from "vue-property-decorator";
import { Message } from "@/api/message-api";

import ProjectMemberSelect, {
  ProjectMemberSelectOption
} from "./project/ProjectMemberSelect.vue";
import ProjectManager from "../entities/project-manager";
import ProjectWorker from "../entities/project-worker";
import ProjectMember from "../entities/project-member";
import User from "../models/user";

interface Tab {
  title: string;
  active: boolean;
  options: ProjectMemberSelectOption[];
}

@Component({
  components: {
    ProjectMemberSelect
  }
})
export default class VMessageControl extends Vue {
  @Prop({ required: true }) message!: Message;

  // ポップオーバーのIDは重複しないように適当な値を設定する
  target = uuid();

  get tabs(): Tab[] {
    return [
      {
        title: "管理者",
        active: true,
        options: this.managerOptions
      },
      {
        title: "作業者",
        active: false,
        options: this.workerOptions
      }
    ];
  }

  get selectedMemberNames() {
    return this.selectedMembers.map(m => `${m.member.name}さん`).join("、");
  }

  get selectedMembers() {
    return [
      ...this.managerOptions.filter(m => m.selected),
      ...this.workerOptions.filter(m => m.selected)
    ];
  }

  get managerOptions(): ProjectMemberSelectOption[] {
    return this.managers
      .filter(m => m.userId !== this.user.id && m.isHiddenInfo === 0)
      .map(m => ({
        value: String(m.projectMemberId),
        member: {
          name: m.name,
          icon: m.icon,
          belongsTo: m.group.name
        },
        // TODO: anyやめる
        selected: (this.message.to as any[]).includes(String(m.projectMemberId))
      }));
  }

  get workerOptions(): ProjectMemberSelectOption[] {
    return this.workers
      .filter(
        m =>
          m.userId !== this.user.id &&
          m.inviteStatus == "招待済" &&
          m.isHiddenInfo === 0
      )
      .map(m =>
        ProjectMemberSelectOptionDecorator(m, this.message.to as any[])
      );
  }

  /* Store */

  private get user(): User {
    return this.$store.getters.user;
  }

  private get managers(): ProjectManager[] {
    return this.$store.getters["member/assigned-managers"];
  }

  private get workers(): ProjectWorker[] {
    return this.$store.getters["member/assigned-workers"];
  }

  getName(member: { staff?: { name: string }; user?: { name: string } }) {
    if (member.staff) {
      return member.staff.name;
    } else if (member.user) {
      return member.user.name;
    } else {
      return "";
    }
  }
}

function ProjectMemberSelectOptionDecorator(
  member: ProjectMember,
  selectedIds: string[]
): ProjectMemberSelectOption {
  const value = String(member.projectMemberId);
  return {
    value,
    member: {
      name: member.name,
      icon: member.icon,
      belongsTo: member.group.name
    },
    // TODO: なんか変？
    selected: (selectedIds as string[]).includes(value)
  };
}
